<template>
        <nav>
            <div class="nav-wrapper">
                <div class="line">
                    <div ref="progress" class="progress-bar"></div>
                </div>
                <!-- <div class="nav-marker-wrapper">
                    <NavMarker v-for="marker in markers" v-bind:key="marker.tag" v-bind:marker="marker" />
                </div> -->
            </div>
        </nav>
</template>

<script>
// import NavMarker from "./NavMarker.vue";

export default {
    name: 'NavBar',
    components: {
        // NavMarker
    },
    // data() {
    //     return {
    //     markers: [
    //         { tag: 1, a: "The", b: "Earth", c: ""},
    //         { tag: 2, a: "Intro", b: "", c: ""},
    //         { tag: 3, a: "The", b: "Layers", c: ""},
    //         { tag: 4, a: "Magnetic", b: "Fields", c: ""},
    //         { tag: 5, a: "Tectonic", b: "Plates", c: ""},
    //         { tag: 6, a: "The", b: "Earth is", c: "a Sphere"}
    //     ]
    //     }
    // },
    mounted () {
        // console.log(this.$refs);
        // window.addEventListener('scroll', function(){
        //     var scrollPos = window.scrollY;
        //     var winHeight = window.innerHeight;
        //     var docHeight = document.documentElement.scrollHeight;
        //     var perc = 100 * scrollPos / (docHeight - winHeight);
        //     // this.$refs.progress.style.height = perc + '%';
        //     console.log(scrollPos+" "+perc);
        //     console.log(this.$refs);
        // })
        // window.addEventListener('scroll', scroller, true);
    },
    methods: {
        handleScroll() {
            // console.log("scrolling");
            var scrollPos = window.scrollY;
            var winHeight = window.innerHeight;
            var docHeight = document.documentElement.scrollHeight;
            var perc = 100 * scrollPos / (docHeight - winHeight);
            this.$refs.progress.style.height = perc + '%';
            // console.log(scrollPos+" "+perc);
            // setTimeout(1000);
        },
        roundColor() {
            this.$refs.progress.style.backgroundColor = "#2D7BE5";
        },
        flatColor() {
            this.$refs.progress.style.backgroundColor = "#459300";
        },
        hollowColor() {
            this.$refs.progress.style.backgroundColor = "#D2841A";
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    }
}
</script>

<style scoped>
    nav {
        height: 60.5vh;
        width: 240px;
        /* background-color: red; */
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
        left: 100px;
        z-index: 99;
        /* padding-left: 20px; */
        /* border-bottom: 1px solid #212121; */
    }

    .nav-wrapper {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: space-between;
        /* background-color: green; */
    }

    .line {
        height: 100%;
        width: 2px;
        background-color: #212121;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        transition: width .3s ease-in-out;
    }

    .progress-bar {
        width: 100%;
        /* height: 33%; */
        background-color: #ffffff;
        transition: height .2s ease, background-color 1s ease-in-out;
    }

    .nav-marker-wrapper {
        /* width: 75%; */
        height: 100%;
        margin: auto;
        /* background-color: yellow; */
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        /* top: calc(50% - 10px); */
        left: 50%;
        transform: translateX(-50%);
    }

    .nav-wrapper:hover .line{
        width: 10px;
    }

</style>